<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button v-if="backRole('SM_4')" type="primary" @click="isCreateSeal=true" size="mini">添加印章</el-button>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column label="印章名称">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column prop="num" label="数量" width="60px" align="center">
      </el-table-column>
      <el-table-column prop="stockNum" width="60px" label="在库数" align="center">
      </el-table-column>
      <el-table-column label="审批领导" width="180px" align="center">
        <template slot-scope="scope">
          <user-info :userData='scope.row.leader'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="保管人" width="180px" align="center">
        <template slot-scope="scope">
          <user-info :userData='scope.row.admin'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="使用/外带记录" width="150px">
        <template slot-scope="scope">
          <el-button type="success" plain size="mini" @click="showLog(scope.row)">使用/外带记录</el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" v-if="backRole('SM_4')" width="80px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑印章信息" placement="bottom">
            <el-button type="primary" class="h1-edit" icon="el-icon-edit" circle @click="editSeal(scope.row)">
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除该印章" placement="bottom">
            <el-button type="danger" class="h1-edit" icon="el-icon-delete" circle @click="delSeal(scope.row)">
            </el-button>
          </el-tooltip>

        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 新建/编辑印章 -->
    <div class="pop-room seal-add-pop" v-if="isCreateSeal">
      <a href="javascript:;" @click="hideSealPop()" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="所属公司">
              <el-select size="small" class="organization-select" v-model="form.depId" placeholder="请选择所属公司">
                <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="印章名称">
              <el-input size="small" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="印章数量">
              <el-col :span="10">
                <el-input-number size="small" v-model="form.num" :min="1" :max="10" label=""></el-input-number>
              </el-col>
            </el-form-item>
            <el-form-item label="印章审批领导">
              <!-- <el-col :span="1"> -->
              <user-info style="float:left;width:auto;" v-if="sealLeader" :userData='sealLeader'></user-info>
              <el-button @click="addUsers(1)" style="margin-left:10px;" round size="mini" type="primary">选择</el-button>
              <!-- </el-col> -->
            </el-form-item>
            <el-form-item label="印章保管人">
              <!-- <el-col :span="10"> -->
              <user-info style="float:left;width:auto;" v-if="sealAdmin" :userData='sealAdmin'></user-info>
              <el-button @click="addUsers(2)" style="margin-left:10px;" round size="mini" type="primary">选择</el-button>
              <!-- </el-col> -->
            </el-form-item>

            <el-form-item label="">
              <el-button @click="addSeal()" class="form-btn" type="success">确认添加印章</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

    <!-- 使用/外带记录 -->
    <log :logStatus="logStatus" v-on:hideLog="hideLog()" :sealName="sealName" :logSealId="logSealId"></log>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Log from './log'
  import Role from '@/Mixins/role'
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      Log,
      UserInfo,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
        contactType: state => state.main.contactType,
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        noSelectOrganization: true,

        // 是否显示log
        logStatus: false,
        logSealId: "",
        sealName: "",

        // 添加印章
        isCreateSeal: false,
        form: {
          depId: "",
          name: "",
          num: ""
        },
        leaderType: "",
        sealAdmin: "",
        sealLeader: "",

        organizationListData: [],
        depId: '',
        addMeetingRoomStatus: false,

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7") {
        this.noSelectOrganization = false
        // this.depId = 0
      }

      this.getLists()
    },
    methods: {
      // 选择更换项目/款项负责人
      addUsers(type) {
        this.leaderType = type
        let _sr = []
        switch (type) {
          case 1:
            if (this.sealLeader) {
              _sr.push(this.sealLeader)
            }
            break;
          case 2:
            if (this.sealAdmin) {
              _sr.push(this.sealAdmin)
            }
            break;
        }
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', true)
      },

      // 隐藏印章 Log
      hideLog() {
        this.logStatus = false
      },
      // 显示印章 Log
      showLog(row) {
        this.logStatus = true
        this.logSealId = row.id
        this.sealName = row.name
      },

      // 隐藏印章编辑弹窗
      hideSealPop() {
        this.form = {
          depId: "",
          name: "",
          num: ""
        }
        this.isCreateSeal = false
      },
      // 编辑印章
      editSeal(row) {
        this.form.depId = row.depId
        this.form.name = row.name
        this.form.num = row.num
        this.form.sealId = row.id
        this.sealLeader = row.leader
        this.sealAdmin = row.admin

        this.isCreateSeal = true
      },
      // 删除印章
      delSeal(row) {
        this.$confirm('此操作将永久删除该印章, 此过程不可逆，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/seal/del', {
            sealId: row.id
          }, (res) => {
            this.$message.error("删除印章成功")
            // 重新获取列表
            this.getLists()
          })
        }).catch(() => {});
      },
      addSeal() {
        if (!this.form.name) {
          this.$message.error("印章名称不能为空")
        }

        let _url = this.form.sealId ? '/seal/edit' : '/seal/add'
        this.form.leaderId = this.sealLeader ? this.sealLeader.id : ""
        this.form.adminId = this.sealAdmin ? this.sealAdmin.id : ""


        if (!this.form.leaderId) {
          this.$message.error("印章审批领导不能为空")
        }
        if (!this.form.adminId) {
          this.$message.error("印章保管人不能为空")
        }

        ajax.post(_url, this.form, (res) => {
          this.$message.success("提交成功")
          this.hideSealPop()
          this.getLists()
        })
      },
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/seal/list', {
          'depId': this.depId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      contactSelectArr() {
        if (this.contactSelectArr.length < 1 || this.contactType) {
          return
        }
        this.selectArr = this.contactSelectArr
        let _p = this.selectArr[0]
        // 如果印章领导发生变化
        if ((!this.sealLeader || _p.id != this.sealLeader.id) && this.leaderType == 1) {
          this.sealLeader = _p
        }
        // 如果印章管理员发生变化
        if ((!this.sealAdmin || _p.id != this.sealAdmin.id) && this.leaderType == 2) {
          this.sealAdmin = _p
        }
      },
      'depId'() {
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/seal/list.vue